module.exports = __webpack_public_path__ + "static/media/TERMOS.ec5002c6.pdf";